/**
 * @generated SignedSource<<a9ede4a31c5df166dbaf5b68e733336a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentBlocks_block$data = {
  readonly clickCount: number | null;
  readonly id: string;
  readonly identifier: string | null;
  readonly impressionCount: number | null;
  readonly " $fragmentType": "ContentBlocks_block";
};
export type ContentBlocks_block$key = {
  readonly " $data"?: ContentBlocks_block$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentBlocks_block">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentBlocks_block",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clickCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "impressionCount",
      "storageKey": null
    }
  ],
  "type": "ContentBlock",
  "abstractKey": null
};

(node as any).hash = "05a9c50f315682b2ebe0b525688527d9";

export default node;
